import Payment from './Payment.vue';

export { Payment };
export default Payment;
